export const customThemeTable = {
    table: {
        style: {
            color: '#fff',
            backgroundColor: '#D9D9D9',
            // height: '100%',
            margin: 0
        }
    },
    tableWrapper: {
        style: {
            display: 'table',
            borderRadius: '0px'
            // height: '100%'
            // border: '1px solid red'
        }
    },
    rows: {
        style: {
            fontSize: '12px',
            fontWeight: 400,
            backgroundColor: '#D9D9D9',
            maxHeight: '27px',
            minHeight: '27px',
            height: '27px',
            borderBottom: '0.3px solid grey'
        }
    },
    headRow: {
        style: {
            fontSize: '13px',
            fontWeight: 600,
            color: "white",
            backgroundColor: '#6D6A70',
            maxHeight: '2vmax',
            minHeight: '2vmax',
            height: '2vmax',
            padding: '0.3vmax'
        }
    },
    pagination: {
        style: {
            color: 'black',
            fontSize: '0.8vmax',
            minHeight: '28px',
            backgroundColor: '#D9D9D9',
            width: '100%',
            padding: '0px',
            margin: '0px',
            border: '0px'
        },
        pageButtonsStyle: {
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            padding: 'px',
            margin: 'px',
            cursor: 'pointer',
            transition: '0.4s',
            color: 'black',
            fill: 'black',
            backgroundColor: 'transparent',
            '&:disabled': {
                cursor: 'unset',
                color: 'grey',
                fill: 'grey'
            },
            '&:hover:not(:disabled)': {
                backgroundColor: 'grey'
            },
            '&:focus': {
                outline: 'none',
                backgroundColor: '#D9D9D9'
            }
        }
    }
}
